import React from 'react';
import styles from './ActionText.module.scss';
import clsx from 'clsx';

export enum ActionTextColor {
  Primary = 'primary',
  Dark = 'dark',
}

type OwnProps = {
  text: string;
  testId?: string;
  onClickHandler?: (event: any) => void;
  disabled?: boolean;
  className?: string;
  color?: ActionTextColor;
  Svg?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  svgClassName?: string;
};

export const ActionText = (props: OwnProps) => {
  const {
    text,
    onClickHandler,
    disabled,
    className,
    color = 'default',
    testId,
    Svg,
    svgClassName,
  } = props;
  return (
    <div
      data-test-id={testId}
      aria-disabled={disabled}
      className={clsx(
        styles.actionText,
        styles[`actionText-${color}`],
        className,
      )}
      onClick={(event) => onClickHandler?.(event)}
    >
      {Svg && <Svg className={svgClassName} />}
      {text}
    </div>
  );
};
